<template>
    <div class="upload">
        <div>
            <el-button icon="el-icon-document-copy" type="primary" size="small" style="margin-left: 15px;"
                @click="checkFile" :disabled="hideButton">选择文件</el-button>
            <input type="file" id="fileinput" style="display: none;" @change="checkFileSure" />
            <el-progress :percentage="authProgress"></el-progress>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.cleanVoidId();
    },
    methods: {
        getVoidId(){
            return this.videoId;
        },
        cleanVoidId(){
            console.log("视频上传初始化")
            this.videoId=null;
        },
        checkFile() {
            document.querySelector('#fileinput').click()
        },
        checkFileSure(val) {
            let file = document.querySelector('#fileinput').files[0];
            if (!file) {
                console.log("请先选择需要上传的文件!")
                return
            }
            this.fileName = file.name
            var userData = '{"Vod":{}}'
            if (this.uploader) {
                this.uploader.stopUpload()
                this.authProgress = 0
                this.statusText = ""
            }
            this.uploader = this.createUploader();
            this.uploader.addFile(file, null, null, null, userData);
        },
        // uploaderInfo() {
        //     // this.uploader = this.createUploader();
        // },
        authUpload() {
            // 然后调用 startUpload 方法, 开始上传
            if (this.uploader !== null) {
                this.uploader.startUpload()
                this.uploadDisabled = true
                this.pauseDisabled = false
            }
        },
        createUploader(type) {
            let self = this
            let uploader = new AliyunUpload.Vod({
                timeout: 60000,
                userId: "吉林易成科技",//lishengkaiSTS@1448803853561212.onaliyun.com
                //分片大小默认1 MB，不能小于100 KB
                partSize: 1048576,
                //并行上传分片个数，默认5
                parallel: 5,
                //网络原因失败时，重新上传次数，默认为3
                retryCount: 3,
                //网络原因失败时，重新上传间隔时间，默认为2秒
                retryDuration: 2,
                //是否上报上传日志到视频点播，默认为true
                enableUploadProgress: true,
                localCheckpoint: true, //此参数是禁用服务端缓存，不影响断点续传
                //添加文件成功
                'addFileSuccess': function (uploadInfo) {
                    console.log("添加文件成功: " + uploadInfo)
                    self.hideButton = true;
                    self.authUpload()
                },
                // 开始上传
                'onUploadstarted': function (uploadInfo) {
                    // console.log("开始上传", uploadInfo);
                    // console.log("addFileSuccess: " + uploadInfo.file.name)
                    let data = {
                    }
                    self.$post(api + "/main/vodUpload/" + uploadInfo.file.name, data).then(response => {
                        let res = response.data;
                        if (res.code == 0) {
                            // console.log("开始文件上传: " + uploadInfo)
                            uploader.setUploadAuthAndAddress(uploadInfo, res.data.uploadAuth, res.data.uploadAddress, res.data.videoId);
                        }
                    })
                },
                // 文件上传成功
                'onUploadSucceed': function (uploadInfo) {
                    console.log("文件上传成功", uploadInfo);
                    self.videoId = uploadInfo.videoId
                    let data = {
                        videoId:uploadInfo.videoId
                    }
                    self.$post(api + "/main/vodEdit", data).then(response => {
                        let res = response.data;
                        if (res.code == 0) {
                            // console.log("开始文件上传: " + uploadInfo)
                        }
                    })
                    self.hideButton = false;
                },
                // 文件上传失败
                'onUploadFailed': function (uploadInfo, code, message) {
                    // console.log("文件上传失败", uploadInfo);
                    self.hideButton = false;
                },
                // 文件上传进度，单位：字节
                'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
                    // console.log("文件上传进度，单位：字节", uploadInfo);
                    // console.log("文件上传进度，单位：字节", uploadInfo, totalSize, loadedPercent);
                    // console.log("文件上传进度，百分比", loadedPercent);
                    self.authProgress = loadedPercent*100;
                },
                // 上传凭证或STS token超时
                'onUploadTokenExpired': function (uploadInfo) {
                    // console.log("上传凭证或STS", uploadInfo);
                },
                // 全部文件上传结束
                'onUploadEnd': function (uploadInfo) {
                    // console.log("全部文件上传结束", uploadInfo);
                    self.hideButton = false;
                }
            });
            return uploader
        },
    },
    data() {
        return {
            authProgress:0,
            fileName: null,
            uploader: null,
            videoId: null,
            hideButton:false,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/VodUpload.vue